import MenuIcon from '@material-ui/icons/Menu';
import { useLocation } from 'react-router-dom';
import BussinessSummary from './BusinessSummary/BussinessSummary';
import UserSummary from './UserSummary';
import {
  AccountingIcon,
  AssetsIcon,
  BusinessDirectoryIcon,
  BusinessSummaryWrapper,
  DashboardIcon,
  DocGenIcon,
  FleetIcon,
  FleetManagementIcon,
  MenuLink as Link,
  LinkTitle,
  MenuButton,
  MenuItem,
  MenuItems,
  PayrollIcon,
  Wrapper
} from './styled.side-nav';

const navItems = [
  {
    title: 'dashboard',
    link: '/dashboard',
    icon: ({ isactive }) => <DashboardIcon isactive={isactive} />
  },
  {
    title: 'accounting',
    link: '/accounts?tab=overview-home',
    icon: ({ isactive }) => <AccountingIcon isactive={isactive} />
  },
  {
    title: 'human resources',
    link: '/hr?type=all-employees&tab=all-employee-home',
    icon: ({ isactive }) => <FleetManagementIcon isactive={isactive} />
  },
  {
    title: 'fleet management',
    link: '/fleet?tab=home',
    icon: ({ isactive }) => <FleetIcon isactive={isactive} />
  },
  {
    title: 'Assets management',
    link: '/assets?tab=home',
    icon: ({ isactive }) => <AssetsIcon isactive={isactive} />
  },
  {
    title: 'Business Directory',
    link: '/business-directory',
    icon: ({ isactive }) => <BusinessDirectoryIcon isactive={isactive} />
  },
  {
    title: 'Doc Gen',
    link: '/doc-gen?tab=home',
    icon: ({ isactive }) => <DocGenIcon isactive={isactive} />
  },
  {
    title: 'Payroll',
    link: '/payroll?tab=home',
    icon: ({ isactive }) => <PayrollIcon isactive={isactive} />
  }
];

const Links = ({ width = 'initial' }) => {
  const { pathname } = useLocation();
  const _active = pathname.split('/').filter((i) => !!i)[0];

  return navItems.map((item) => {
    const isActive = item.link.includes(_active).toString();

    return (
      <MenuItem key={item.title} isactive={isActive} width={width}>
        <Link isactive={isActive} to={item.link}>
          <MenuButton width={width}></MenuButton>
          <LinkTitle width={width}> {item.title}</LinkTitle>
        </Link>
      </MenuItem>
    );
  });
};

function SideNav({ hide, width = 'initial', toggleWidth }) {
  return (
    <Wrapper hide={hide} width={width}>
      <BusinessSummaryWrapper width={width}>
        <MenuIcon onClick={toggleWidth} />
        <BussinessSummary width={width} />
      </BusinessSummaryWrapper>
      <UserSummary width={width} />
      <MenuItems>
        <Links width={width} />
      </MenuItems>
    </Wrapper>
  );
}

export default SideNav;
